<template>
  <div class="row">
    <div class="col-md-5">{{ label }}</div>
    <div class="col-md-7">{{ value }}</div>
  </div>
</template>

<script>
  export default {
    props: [
      'label',
      'value',
    ],
  };
</script>
